import { render, staticRenderFns } from "./look-dialog.vue?vue&type=template&id=ba32e9da&scoped=true&"
import script from "./look-dialog.vue?vue&type=script&lang=js&"
export * from "./look-dialog.vue?vue&type=script&lang=js&"
import style0 from "./look-dialog.vue?vue&type=style&index=0&id=ba32e9da&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba32e9da",
  null
  
)

export default component.exports